import {useCallback, useEffect, useRef, useState} from 'react';

import {Grid, GridColumn, GridNoRecords} from "@progress/kendo-react-grid";
import {ColumnMenu, NoWrapCell} from "../../common/Grid";
import {Checkbox} from "@progress/kendo-react-inputs";
import {filterBy, process} from "@progress/kendo-data-query";


export default function GenericSelectGrid(props) {
    const {
        items,
        setItems,
        selectID = 'selected',
        uniqueID,
        gridState,
        setGridState,
        initialGridState,
        selectHeaderCheck,
        setSelectHeaderCheck,
        onItemChange = () => {
        },
        filterOut = () => {
            return true
        },
        children,
        ...otherGridProps
    } = props;

    const defaultHeaderClass = 'ksm-default-header'
    const disableHeaderClass = 'ksm-deactivate-header'
    const [selectHeaderClass, setSelectHeaderClass] = useState(disableHeaderClass)

    //States and functions for pagination
    const gridStateRef = useRef(initialGridState)
    const [dataState, setDataState] = useState(
        process(items
            .map((item) => ({
                ...item,
            })), initialGridState)
    );

    const onDataStateChange = useCallback((event) => {
        const newDataState = process(
            items
                .map((item) => ({
                    ...item,
                })),
            event.dataState
        );
        if (newDataState.data.length === 0) {
            setSelectHeaderCheck(false)
        } else {
            setSelectHeaderCheck(newDataState.data.filter(item => !item[selectID]).length === 0)
        }
        gridStateRef.current = event.dataState
        setGridState(event.dataState);
        setDataState(newDataState);
    }, [items]);

    useEffect(() => {
        const newDataState = process(
            items
                .map((item) => ({
                    ...item,
                })),
            gridState
        );
        setDataState(newDataState);
    }, [items]) // eslint-disable-line react-hooks/exhaustive-deps

    //Cell and functions for selection
    const SelectCell = (props) => {
        return <td>
            <Checkbox
                type="checkbox"
                onChange={props.selectionChange}
                value={props.dataItem[props.field]}
            />
        </td>
    }

    const onSelectionChange = useCallback((event) => {
        const checked = event.syntheticEvent.target.checked
        let allChecked = true
        let newItems = items.map(item => {
            if (event.dataItem[uniqueID] === item[uniqueID]) {
                item[selectID] = checked
            }
            if (!item[selectID]) {
                allChecked = false
            }
            return item
        })
        setSelectHeaderCheck(filterBy(newItems, gridStateRef.current.filter).filter(item => !item[selectID]).length === 0)
        setItems(newItems)
    }, [items]); // eslint-disable-line react-hooks/exhaustive-deps

    const onHeaderSelectionChange = useCallback(event => {
        const checked = event.nativeEvent.target.checked;
        let newItems = items.map(item => {
            for (const filtered of filterBy(items, gridStateRef.current.filter)) {
                if (item[uniqueID] === filtered[uniqueID]) {
                    item[selectID] = checked
                }
            }
            return item
        });
        if (newItems.length !== 0) setSelectHeaderCheck(checked)
        setItems(newItems)
    }, [items]); // eslint-disable-line react-hooks/exhaustive-deps

    //enable or disable header if there are items
    useEffect(() => {
        setSelectHeaderClass(filterBy(items, gridStateRef.current.filter).length > 0 ?
            defaultHeaderClass : disableHeaderClass
        )
    },[items, dataState]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <Grid
                scrollable={'none'}
                data={dataState}
                sortable={true}
                //pagination
                pageable={(items.length <= initialGridState.take) ? false : {
                    buttonCount: 5,
                    pageSizes: [10, 20, 50, 100],
                }}
                onDataStateChange={onDataStateChange}
                total={dataState.total}
                //select checkboxes
                onHeaderSelectionChange={onHeaderSelectionChange}
                onSelectionChange={onSelectionChange}
                selectedField={selectID}
                //editing fields
                editField="inEdit"
                onItemChange={onItemChange}
                {...gridState}
                {...otherGridProps}
            >
                <GridColumn
                    field={selectID}
                    cell={SelectCell}
                    headerSelectionValue={selectHeaderCheck}
                    headerClassName={selectHeaderClass}
                />
                {children}
            </Grid>
        </>
    )
}